import React from 'react';
import { bespokeUpperConfig } from '../config/bespokeBackgrounds'; 
import { getBespokeConfig } from '../utils/ui.utils';

export const BespokeVisual = ({ brand, grs, treatment, data_email, data_math, data }) => {
  // Use centralized logic to resolve config
  // We prioritize 'data' object if passed, otherwise construct a shim from props
  const resolutionData = data || { grs, normalizedTreatment: treatment, email: data_email, math: data_math };
  const config = getBespokeConfig(brand, bespokeUpperConfig, resolutionData);

  if (!config) {
    return null;
  }

  const finalStyle = {
    backgroundImage: config.bgSrc,
    opacity: config.opacity !== undefined ? config.opacity : undefined,
    backgroundPosition: config.backgroundPosition !== undefined ? config.backgroundPosition : undefined
  };

  const lot = data?.display_lot || data?.display_lotAlt || '';
  
  return (
    <div className="il upper-bg" style={finalStyle}>
      {treatment === "ExpeDRY" ? (
        <a
          href={`//alliedfeather.com/innovation/expedry?ref=tmd-com&lot=${lot}`}
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      ) : null}
    </div>
  );
};